import { activityClientRoutes } from '@cash-web/account-activity-feature-client-routes'
import { bitcoinClientRoutes } from '@cash-web/account-bitcoin-feature-client-routes'
import { cardClientRoutes } from '@cash-web/account-card-feature-client-routes'
import { cashClientRoutes } from '@cash-web/account-cash-feature-client-routes'
import { deviceManagerClientRoutes } from '@cash-web/account-device-manager-feature-client-routes'
import { documentsClientRoutes } from '@cash-web/account-documents-feature-client-routes'
import { p2pClientRoutes } from '@cash-web/account-p2p-feature-client-routes'
import { paychecksClientRoutes } from '@cash-web/account-paycheck-feature-client-routes'
import { savingsClientRoutes } from '@cash-web/account-savings-feature-client-routes'
import { settingsClientRoutes } from '@cash-web/account-settings-feature-client-routes'
import { stocksClientRoutes } from '@cash-web/account-stocks-feature-client-routes'
import { cashtagP2PClientRoutes } from '@cash-web/cashtag-p2p-feature-client-routes'
import { poolsClientRoutes } from '@cash-web/pools-feature-client-routes'
import { flowClientRoutes } from '@cash-web/shared-flow-feature-client-routes'
import { oonClientRoutes } from '@cash-web/shared-oon-feature-client-routes'
import { supportClientRoutes } from '@cash-web/support-feature-client-routes'
import { taxesClientRoutes } from '@cash-web/taxes-hub-feature-client-routes'

import { errorJourneyRoutes } from './lib/error/routes'

export const commonJourneyRoutes = [
  ...errorJourneyRoutes,

  // migrated client route libs
  ...activityClientRoutes,
  ...bitcoinClientRoutes,
  ...cardClientRoutes,
  ...cashClientRoutes,
  ...cashtagP2PClientRoutes,
  ...deviceManagerClientRoutes,
  ...documentsClientRoutes,
  ...flowClientRoutes,
  ...oonClientRoutes,
  ...p2pClientRoutes,
  ...paychecksClientRoutes,
  ...poolsClientRoutes,
  ...savingsClientRoutes,
  ...settingsClientRoutes,
  ...stocksClientRoutes,
  ...supportClientRoutes,
  ...taxesClientRoutes,
]
